import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    childContainer: {
      minWidth: 648,

      [mediaQuery(breakpoints.tablet)]: {
        minWidth: 'auto',
      },
    },
    imgContainer: {
      textAlign: 'center',

      [mediaQuery(breakpoints.laptop)]: {
        width: '100%',
      },
    },
    img: {
      [mediaQuery(breakpoints.laptop)]: {
        maxWidth: '100%',
        marginLeft: 0,
      },
    },

    normal: {
      marginLeft: 60,

      [mediaQuery(breakpoints.largeDesktop)]: {
        marginLeft: 0,
      },
    },
    inverse: {
      marginLeft: 0,
    },
  }),
  {
    name: 'Media',
  },
);

export default useStyles;
